import React from 'react';
import { Toggle } from '@silverfort/sf-components';

interface Props {
    id: string;
    isActive: boolean;
    onToggle: (id: string, isActive: boolean) => void;
}

const ExposureToggleColumn: React.FC<Props> = ({ id, isActive, onToggle }) => {
    return (
        <div className="flex items-center justify-center">
            <Toggle
                className='mt-1'
                checked={isActive}
                onChange={(checked) => onToggle(id, checked)}
            />
        </div>
    );
};

export default ExposureToggleColumn;
